import { restApiDP } from "@plannel/services/utils/rest-api";

const get = () => {
    return restApiDP.get("/api/dp-scenario-comparison")
};

const saveSummaryObj = (params) => {
    return restApiDP.post("/api/dp-scenario-comparison/summary-obj", params)
};

const dpScenarioComparisonService = {
    get,
    saveSummaryObj
}

export default dpScenarioComparisonService;